import { render, staticRenderFns } from "./LoadingDataSep.vue?vue&type=template&id=e6d2376c&scoped=true&"
import script from "./LoadingDataSep.vue?vue&type=script&lang=js&"
export * from "./LoadingDataSep.vue?vue&type=script&lang=js&"
import style0 from "./LoadingDataSep.vue?vue&type=style&index=0&id=e6d2376c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d2376c",
  null
  
)

export default component.exports